import React, { useState, useEffect } from 'react'
import './Navbar.css'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import cart_icon from '../Assets/Cart.png'
import { useCart } from '../Cart'
import { useAuth } from '../../Context/AuthContext'

const pathToMenu = {
  '/': 'home',
  '/Tcg': 'tcg',
  '/TcgAccessories': 'accessories',
  '/BoardGames': 'board_games',
  '/AboutUs': 'about',
  '/ContactUs': 'contact',
}

const Navbar = () => {
  const location = useLocation()
  const [menu, setMenu] = useState(() => pathToMenu[location.pathname] || 'home');
  const [activeDropdown, setActiveDropdown] = useState(null)
  const [mobileOpen, setMobileOpen] = useState(false)
  const { cartCount } = useCart()
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const [userDropdown, setUserDropdown] = useState(false)

  useEffect(() => {
    setMobileOpen(false)
    setActiveDropdown(null)
  }, [location.pathname])

  const handleNavClick = (menuItem) => {
    setMenu(menuItem)
    setMobileOpen(false)
    setActiveDropdown(null)
    setUserDropdown(false)
  }

  const handleLogout = () => {
    logout()
    setUserDropdown(false)
    navigate('/')
  }

  const handleTcgDropdownToggle = (e) => {
    if (window.innerWidth <= 768 && activeDropdown !== 'tcg') {
      e.preventDefault()
      setActiveDropdown('tcg')
    } else {
      handleNavClick('tcg')
    }
  }

  const handleAccessoriesDropdownToggle = (e) => {
    if (window.innerWidth <= 768 && activeDropdown !== 'accessories') {
      e.preventDefault()
      setActiveDropdown('accessories')
    } else {
      handleNavClick('accessories')
    }
  }

  return (
    <nav className='navbar bg-pink-50'>

      <Link to='/' className='nav-logo'>
        <img src="" alt="Tagers Shoppe Logo" />
      </Link>

      <button
        className='nav-hamburger'
        onClick={() => setMobileOpen(prev => !prev)}
        aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={mobileOpen}
      >
        <span className={`hamburger-line ${mobileOpen ? 'open' : ''}`} />
        <span className={`hamburger-line ${mobileOpen ? 'open' : ''}`} />
        <span className={`hamburger-line ${mobileOpen ? 'open' : ''}`} />
      </button>

      <ul className={`nav-menu${mobileOpen ? ' mobile-menu-open' : ''}`}>

        <li onClick={() => { handleNavClick('home') }}> <Link to='/'> Home </Link>{menu === 'home' ? <hr /> : <></>} </li>
        
        <li
          className='nav-dropdown-trigger'
          onMouseEnter={() => setActiveDropdown('tcg')}
          onMouseLeave={() => setActiveDropdown(null)}
        >
          <Link to='/Tcg' onClick={handleTcgDropdownToggle}> TCG </Link>{menu === 'tcg' ? <hr /> : <></>}
          {activeDropdown === 'tcg' && (
            <div className='nav-dropdown'>
              <Link to='/Tcg?franchise=mtg' onClick={() => handleNavClick('tcg')}>Magic: The Gathering</Link>
              <Link to='/Tcg?franchise=onepiece' onClick={() => handleNavClick('tcg')}>One Piece</Link>
              <Link to='/Tcg?franchise=riftbound' onClick={() => handleNavClick('tcg')}>Riftbound</Link>
            </div>
          )}
        </li>
        <li
          className='nav-dropdown-trigger'
          onMouseEnter={() => setActiveDropdown('accessories')}
          onMouseLeave={() => setActiveDropdown(null)}
        >
          <Link to='/TcgAccessories' onClick={handleAccessoriesDropdownToggle}> TCG Accessories </Link>{menu === 'accessories' ? <hr /> : <></>}
          {activeDropdown === 'accessories' && (
            <div className='nav-dropdown'>
              <Link to='/TcgAccessories?brand=dragonShield' onClick={() => handleNavClick('accessories')}>Dragon Shield</Link>
              <Link to='/TcgAccessories?brand=luckDragon' onClick={() => handleNavClick('accessories')}>Luck Dragon</Link>
              <Link to='/TcgAccessories?brand=sleeveKings' onClick={() => handleNavClick('accessories')}>Sleeve Kings</Link>
              <Link to='/TcgAccessories?brand=armyPainter' onClick={() => handleNavClick('accessories')}>Army Painter</Link>
              <Link to='/TcgAccessories?brand=gradedGuard' onClick={() => handleNavClick('accessories')}>Graded Guard</Link>
              <Link to='/TcgAccessories?brand=dice' onClick={() => handleNavClick('accessories')}>Dice</Link>
            </div>
          )}
        </li>
        <li onClick={() => { handleNavClick('board_games') }}> <Link to='/BoardGames'> Board Games </Link>{menu === 'board_games' ? <hr /> : <></>} </li>
        <li onClick={() => { handleNavClick('about') }}> <Link to='/AboutUs'> About Us </Link>{menu === 'about' ? <hr /> : <></>} </li>
        <li onClick={() => { handleNavClick('contact') }}> <Link to='/ContactUs'> Contact Us </Link>{menu === 'contact' ? <hr /> : <></>} </li>

      </ul>

      <div className='nav-login'>
        {user ? (
          <div
            className='nav-user-wrap'
            onMouseEnter={() => setUserDropdown(true)}
            onMouseLeave={() => setUserDropdown(false)}
          >
            <Link to='/Profile' onClick={() => setUserDropdown(false)} style={{ display: 'flex', alignItems: 'center', padding: '6px 8px', textDecoration: 'none' }}>
              <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 24 24' fill='none' stroke='#7c3aed' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                <path d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2' />
                <circle cx='12' cy='7' r='4' />
              </svg>
            </Link>
            {userDropdown && (
              <div className='nav-user-dropdown'>
                <div className='nav-user-dropdown-name'>{user.name}</div>
                <Link to='/Profile' onClick={() => setUserDropdown(false)}>My Profile</Link>
                <button onClick={handleLogout}>Sign Out</button>
              </div>
            )}
          </div>
        ) : (
          <>
            <Link to='/LogIn'><button>Login</button></Link>
            <Link to='/SignUp'><button>Sign up</button></Link>
          </>
        )}
        <div className='nav-cart-wrap'>
          <Link to='/Cart'><img src={cart_icon} alt='Cart Icon' /></Link>
          {cartCount > 0 && <div className='nav-cart-count'> {cartCount} </div> }
        </div>
      </div>

    </nav>
  )
}

export default Navbar
